<div class="calendar-navigation">
    <button mat-icon-button (click)="previousMonth()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span class="month-label">
      {{ getMonthYearLabel() }}
    </span>
    <button mat-icon-button (click)="nextMonth()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

<div class="preset-picker">
    <button mat-button *ngFor="let item of customPresets" color="primary" class="preset"
        (click)="selectRange(item)" [class.preset]="item == selectedRange">
        {{ item }}
    </button>
</div>